import { observer } from "mobx-react";
import { useEffect, useRef } from "react";

const PopupMenu = ({
  children,
  MenuContent,
  actionType,
  open,
  setOpen = () => {},
  type,
  position,
  showArrow,
  popupMenuClass,
  disabledPopup,
  ref,
  restrictHover = false,
  btnClass = "",
  id = "",
  role = "menu",
  ariaHasPopUp = "menu",
  ariaExpanded = false,
  ariaControls = "",
  containerClass = "",
}) => {
  const wrapperRef = useRef(null);
  const popupRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const handleMenuToggle = () => {
    if (disabledPopup) return;
    setOpen(!open);
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const handleTabKeyPress = (event) => {
    const modalElement = popupRef.current;
    //add any focusable HTML element you want to include to this string
    const focusableElements = modalElement.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (event.key === "Tab") {
      const focusableElementsArray = Array.from(focusableElements);
      const focusedIndex = focusableElementsArray.indexOf(
        document.activeElement
      );

      if (event.shiftKey) {
        // Shift + Tab pressed
        if (focusedIndex === 0) {
          event.preventDefault();
          focusableElementsArray[focusableElementsArray.length - 1].focus();
        }
      } else {
        // Tab pressed
        if (focusedIndex === focusableElementsArray.length - 1) {
          event.preventDefault();
          focusableElementsArray[0]?.focus();
        }
      }
    }
  };

  const handleEscapeKeyPress = (event) => {
    if (event.key === "Escape") {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      const modalElement = popupRef.current;

      modalElement.addEventListener("keydown", handleTabKeyPress);
      modalElement.addEventListener("keydown", handleEscapeKeyPress);
      popupRef.current.focus();

      return () => {
        modalElement.removeEventListener("keydown", handleTabKeyPress);
        modalElement.removeEventListener("keydown", handleEscapeKeyPress);
      };
    }
  }, [open]);

  return (
    <div
      className={`${
        type === "custom"
          ? "menu_list"
          : type === "customNifty"
          ? "menu_list_performance"
          : type === "multiSort"
          ? "popup_menu_container sortingMenu"
          : "popup_menu_container"
      } ${containerClass}`}
    >
      <button
        // style={{
        //   width: "fit-content",
        //   padding: "0",
        //   border: "none",
        //   background: "none",
        // }}
        id={id}
        role={role !== "combobox" ? undefined : role}
        className={`children buttonWrapper ${btnClass}`}
        style={{ width: "fit-content" }}
        onClick={handleMenuToggle}
        aria-haspopup={ariaHasPopUp}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
      >
        {children}
      </button>
      {actionType === "hover" ? (
        <div
          id={id}
          role={role}
          style={{ ...position }}
          className={
            type === "custom" || type === "customNifty"
              ? "list_menu list_menu_hover 1111"
              : `popup_menu popup_menu_hover 2222 ${
                  restrictHover ? "restrict_hover" : ""
                }`
          }
        >
          <MenuContent />
        </div>
      ) : (
        <div
          id={id}
          role={role}
          style={{ ...position }}
          ref={ref}
          className={
            type === "custom" || type === "customNifty"
              ? `3333 list_menu ${open ? "list_menu_open" : "list_menu_close"}`
              : `4444 popup_menu ${popupMenuClass || ""}  ${
                  showArrow === false ? "no_arrow" : ""
                } ${open ? "popup_menu_open" : "popup_menu_close"}`
          }
          ref={popupRef}
        >
          {MenuContent()}
        </div>
      )}
    </div>
  );
};

export default observer(PopupMenu);


<div className="parent">
  <div className="child-1"></div>
  <div className="child-2"></div>
</div>